import { useAppSelector } from "../redux/store/storehooks";
import type { MenuProps } from 'antd';
import {
    DesktopOutlined, MailOutlined, ScheduleOutlined, HistoryOutlined, BankOutlined, MedicineBoxOutlined, ProfileOutlined, SaveOutlined,
    TagsOutlined, WifiOutlined, PlusOutlined, ClusterOutlined, CloudSyncOutlined, CloudOutlined, PullRequestOutlined,
    GlobalOutlined, CheckCircleOutlined, CloudDownloadOutlined, AndroidOutlined, DownloadOutlined,
    CheckOutlined, BookOutlined, DollarCircleOutlined, FileSyncOutlined, ExperimentOutlined,
    FileProtectOutlined, SelectOutlined, DollarOutlined, BranchesOutlined
} from '@ant-design/icons';
import React, { useEffect, useState } from "react";
//import MenuItem from "antd/lib/menu/MenuItem";



type MenuItem = Required<MenuProps>['items'][number];


function getItemLab(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: 'group',
): MenuItem {
    return {
        key,
        icon,
        children,
        label,
        type,
    } as MenuItem;
}

function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    type?: 'group',
    path?: string,
    children?: MenuItem[],
): MenuItem {
    return {
        key,
        icon,
        children,
        label,
        type,
        path,
    } as MenuItem;
}

const DrawerMenu = () => {
    const [parsicuserItems, setParsicuserItems] = useState<any>([]);

    const auth = useAppSelector((state) => state.auth)
    let parsicuserMenu: MenuItem[] = [];
    let flag = false;

    useEffect(() => {
        if (auth.loginType == "parsicuser" && !flag) {
            let sub1Children: MenuItem[] = [];
            let sub2Children: MenuItem[] = [];
            let sub3Children: MenuItem[] = [];
            let sub4Children: MenuItem[] = [];
            let sub5Children: MenuItem[] = [];
            let sub6Children: MenuItem[] = [];

            auth.permission.map((item: any) => {
                switch (item.pageName) {
                    case 'Lab':
                        sub1Children.push(getItem('مدیریت آزمایشگاها', '1', <MedicineBoxOutlined />, undefined, "/parsicuser/Lab"));
                        break;
                    case 'ticktingManagement':
                        sub1Children.push(getItem('تیکت های من', '2', <TagsOutlined />, undefined, "/parsicuser/ticketManagement"));
                        break;
                    case 'UsersTicket':
                        sub1Children.push(getItem('مدیریت تیکت ها', '26', <TagsOutlined />, undefined, "/parsicuser/UsersTicket"));
                        break;
                    case 'RequestPayment':
                        sub1Children.push(getItem('درگاه پرداخت الکترونیکی', '4', <BankOutlined />, undefined, "/parsicuser/RequestPayment"));
                        break;
                    case 'RequestLab':
                        sub1Children.push(getItem('نصب آزمایشگاه', '3', <SaveOutlined />, undefined, "/parsicuser/RequestLab"));
                        break;
                    case 'machineInstallRequest':
                        sub2Children.push(getItem('نصب دستگاه', '5', <FileProtectOutlined />, undefined, "/parsicuser/machineInstallRequest"));
                        break;
                    case 'temperatureInstallRequest':
                        sub2Children.push(getItem('نصب دماسنج', '19', <FileProtectOutlined />, undefined, "/parsicuser/temperatureInstallRequest"));
                        break;
                    case 'padvishRequest':
                        sub2Children.push(getItem('درخواست ویروس کنترل پادویش', '20', <FileProtectOutlined />, undefined, "/parsicuser/padvishRequest"));
                        break;
                    case 'cableRequest':
                        sub2Children.push(getItem('درخواست کابل', '6', <FileSyncOutlined />, undefined, "/parsicuser/cableRequest"));
                        break;
                    case 'SMSRequest':
                        sub2Children.push(getItem('درخواست پیامک', '7', <MailOutlined />, undefined, "/parsicuser/SMSRequest"));
                        break;
                    case 'financialBalance':
                        sub3Children.push(getItem('صورتحساب مالی', '8', <ProfileOutlined />, undefined, "/parsicuser/financialBalance"));
                        break;
                    case 'versionLogManagement':
                        sub4Children.push(getItem('مدیریت ورژن', '9', <AndroidOutlined />, undefined, "/parsicuser/notfound"));
                        break;
                    case 'versionLogHistory':
                        sub4Children.push(getItem('سوابق ورژن', '10', <BookOutlined />, undefined, "/parsicuser/notfound"));
                        break;
                    case 'latestVersionLog':
                        sub4Children.push(getItem('آخرین ورژن ها', '11', <DownloadOutlined />, undefined, "/parsicuser/notfound"));
                        break;
                    case 'latestBackup':
                        sub4Children.push(getItem('آخرین بکاپ ها', '12', <CloudDownloadOutlined />, undefined, "/parsicuser/notfound"));
                        break;
                    case 'cloudInformation':
                        sub4Children.push(getItem('اطلاعات ابری', '13', <CheckCircleOutlined />, undefined, "/parsicuser/notfound"));
                        break;
                    case 'LabWhiteList':
                        sub4Children.push(getItem('لیست سفید', '27', <CheckCircleOutlined />, undefined, "/parsicuser/LabWhiteList"));
                        break;
                    case 'proxyPol':
                        sub5Children.push(getItem('دستیار (پراکسی)', '14', <PullRequestOutlined />, undefined, "/parsicuser/proxy"));
                        break;
                    case 'cloudChart':
                        sub5Children.push(getItem('چارت ابری', '15', <CloudOutlined />, undefined, "/parsicuser/notfound"));
                        break;
                    case 'cloudConnection':
                        sub5Children.push(getItem('بررسی ارتباطات ابری', '16', <CloudSyncOutlined />, undefined, "/parsicuser/notfound"));
                        break;
                    case 'sqlConnection':
                        sub5Children.push(getItem('SQL از راه دور', '17', <ClusterOutlined />, undefined, "/parsicuser/notfound"));
                        break;
                    case 'Machine':
                        sub6Children.push(getItem('دستگاه', '18', <WifiOutlined />, undefined, "/parsicuser/Machine"));
                        break;
                }

            })

            if (sub1Children.length > 0) {
                let sub1: MenuItem = getItem(' آزمایشگاه', 'sub1', <ExperimentOutlined />, undefined, '', sub1Children);
                parsicuserMenu.push(sub1);
            }
            if (sub2Children.length > 0) {
                let sub2: MenuItem = getItem('درخواست ها ', 'sub2', <SelectOutlined />, undefined, '', sub2Children);
                parsicuserMenu.push(sub2);
            }
            if (sub3Children.length > 0) {
                let sub3: MenuItem = getItem('مالی', 'sub3', <DollarCircleOutlined />, undefined, '', sub3Children);
                parsicuserMenu.push(sub3);
            }
            if (sub4Children.length > 0) {
                let sub4: MenuItem = getItem('کاربردی', 'sub4', <CheckOutlined />, undefined, '', sub4Children);
                parsicuserMenu.push(sub4);
            }
            if (sub5Children.length > 0) {
                let sub5: MenuItem = getItem('کنترل از راه دور', 'sub5', <GlobalOutlined />, undefined, '', sub5Children);
                parsicuserMenu.push(sub5);
            }
            if (sub6Children.length > 0) {
                let sub6: MenuItem = getItem('تعاریف پایه', 'sub6', <PlusOutlined />, undefined, '', sub6Children);
                parsicuserMenu.push(sub6);
            }
            setParsicuserItems(parsicuserMenu);
            flag = true;
        }
    }, []);

    //return auth.loginType == "parsicuser" ? parsicuserItems : labuserMenu;
    return auth.loginType == "parsicuser" ? parsicuserMenu1 : labuserMenu;

}







const parsicuserMenu1: MenuItem[] = [

    getItem(' آزمایشگاه', 'sub1', <ExperimentOutlined />, undefined, '', [
        getItem('مدیریت آزمایشگاها', '1', <MedicineBoxOutlined />, undefined, "/parsicuser/Lab"),
        getItem('تیکت های من', '2', <TagsOutlined />, undefined, "/parsicuser/ticketManagement"),
        getItem('مدیریت تیکت ها', '26', <TagsOutlined />, undefined, "/parsicuser/UsersTicket"),
        getItem('نصب آزمایشگاه', '3', <SaveOutlined />, undefined, "/parsicuser/RequestLab"),
        getItem(' درگاه پرداخت الکترونیکی', '4', <BankOutlined />, undefined, "/parsicuser/RequestPayment"),
    ]),
    getItem('درخواست ها ', 'sub2', <SelectOutlined />, undefined, '', [
        getItem('نصب دستگاه', '5', <FileProtectOutlined />, undefined, "/parsicuser/machineInstallRequest"),
        getItem('نصب دماسنج', '19', <FileProtectOutlined />, undefined, "/parsicuser/temperatureInstallRequest"),
        getItem('درخواست ویروس کنترل پادویش', '20', <FileProtectOutlined />, undefined, "/parsicuser/padvishRequest"),
        getItem('درخواست کابل', '6', <FileSyncOutlined />, undefined, "/parsicuser/cableRequest"),
        getItem('درخواست پیامک', '7', <MailOutlined />, undefined, "/parsicuser/SMSRequest"),
    ]),


    getItem('مالی', 'sub3', <DollarCircleOutlined />, undefined, '', [
        getItem('صورتحساب مالی', '8', <ProfileOutlined />, undefined, "/parsicuser/financialBalance"),
    ]),

    getItem('کاربردی', 'sub4', <CheckOutlined />, undefined, '', [
        getItem('مدیریت ورژن', '9', <AndroidOutlined />, undefined, "/parsicuser/notfound"),
        getItem('سوابق ورژن', '10', <BookOutlined />, undefined, "/parsicuser/notfound"),
        getItem('آخرین ورژن ها', '11', <DownloadOutlined />, undefined, "/parsicuser/notfound"),
        getItem('آخرین بکاپ ها', '12', <CloudDownloadOutlined />, undefined, "/parsicuser/notfound"),
        // getItem('لاگ تنظیمات بکاپ', '10',<DesktopOutlined />,undefined,"/parsicuser/notfound"),
        // getItem('لاگ دماسنج', '11',<DesktopOutlined />,undefined,"/parsicuser/notfound"),
        getItem('اطلاعات ابری', '13', <CheckCircleOutlined />, undefined, "/parsicuser/notfound"),
        getItem('نمایندگی های پارسی پل خودران', '25', <BranchesOutlined />, undefined, "/parsicuser/branchOffice"),
        getItem('لیست سفید', '27', <BranchesOutlined />, undefined, "/parsicuser/LabWhiteList"),

        // getItem('پادویش', '13',<DesktopOutlined />,undefined,"/parsicuser/notfound"),
        // getItem('لیست شکایت ها', '14',<DesktopOutlined />,undefined,"/parsicuser/notfound"),
    ]),

    getItem('کنترل از راه دور', 'sub5', <GlobalOutlined />, undefined, '', [
        getItem('دستیار (پراکسی)', '14', <PullRequestOutlined />, undefined, "/parsicuser/proxy"),
        getItem('چارت ابری', '15', <CloudOutlined />, undefined, "/parsicuser/notfound"),
        getItem('بررسی ارتباطات ابری', '16', <CloudSyncOutlined />, undefined, "/parsicuser/notfound"),
        getItem('SQL از راه دور', '17', <ClusterOutlined />, undefined, "/parsicuser/notfound"),
        getItem('مدیریت ویپ ها', '21', <ClusterOutlined />, undefined, "/parsicuser/voipManagement"),
        getItem(' گزارش‌گیری ویپ ها', '22', <ClusterOutlined />, undefined, "/parsicuser/voipReportManagement"),
        getItem('آخرین ورژن ها ', '23', <ClusterOutlined />, undefined, "/parsicuser/versionManagement"),
        getItem('سوابق ورژن ها', '24', <ClusterOutlined />, undefined, "/parsicuser/versionHistory"),

    ]),

    getItem('تعاریف پایه', 'sub6', <PlusOutlined />, undefined, '', [
        getItem('دستگاه', '18', <WifiOutlined />, undefined, "/parsicuser/Machine"),
    ]),


];


const labuserMenu: MenuItem[] = [

    getItem(' گزارشات', 'sub1', <ScheduleOutlined />, undefined, '', [
        getItem('صورتحساب مالی', '1', <DollarOutlined />, undefined, "/labuser/financialBalance"),
        getItem('درخواست نصب دستگاه', '2', <DesktopOutlined />, undefined, "/labuser/MachineInstallRequest"),
        getItem('خرید پیامک', '3', <MailOutlined />, undefined, "/labuser/SMSRequest"),

    ]),
    getItem('سابقه ', 'sub2', <HistoryOutlined />, undefined, '', [
        getItem('سوابق تیکت ها', '4', <HistoryOutlined />, undefined, "/labuser/notfound"),

    ]),
    getItem('درخواست ها ', 'sub4', <SelectOutlined />, undefined, '', [
        getItem('  آزمایشگاه', '5', <ExperimentOutlined />, undefined, "/labuser/RequestLab"),
        getItem('نصب دماسنج', '7', <FileProtectOutlined />, undefined, "/labuser/temperatureInstallRequest"),
        getItem(' درگاه پرداخت الکترونیکی', '6', <BankOutlined />, undefined, "/labuser/RequestPayment"),
        getItem('درخواست ویروس کنترل پادویش', '8', <FileProtectOutlined />, undefined, "/labuser/padvishRequest"),
    ]),

    getItem('کنترل از راه دور', 'sub5', <GlobalOutlined />, undefined, '', [
        getItem('دستیار (پراکسی)', '14', <PullRequestOutlined />, undefined, "/labuser/labInfo")
    ])
    // getItem('صورتحساب مالی', '1', <ContainerOutlined />,undefined,"/labuser/financialBalance"),
    // getItem('درخواست نصب دستگاه', '2', <DesktopOutlined />,undefined,"/labuser/MachineInstallRequest"),
    // getItem('خرید پیامک', '3', <PieChartOutlined />,undefined,"/labuser/SMSRequest"), 
    // getItem('پشتیبانی', 'sub1', <MailOutlined />,'group','', [
    //   getItem('سوابق تیکت ها', '6',undefined,undefined,"/labuser/notfound"),
    // ]),
    // getItem(' آزمایشگاه', 'sub2', <AppstoreOutlined />,'group','', [

    //    getItem('  آزمایشگاه', '7',<DesktopOutlined />,undefined,"/labuser/RequestLab"),
    //    getItem(' درگاه پرداخت الکترونیکی', '8',<DesktopOutlined />,undefined,"/labuser/RequestPayment"),
    // ]),

];





export default DrawerMenu;